import execution from './execution';
import connectors from './connectors';
import { semanticSearch } from './semanticSearch';
import { ThemeUICSSObject } from 'theme-ui';
/* IMPORT HERE */
const ai: ThemeUICSSObject = {
  connectors,
  execution,
  semanticSearch,
  /* PREPEND HERE */
};

export default ai;
